"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enablePermit = exports.hasPermit = void 0;
var bootstrap_1 = require("./bootstrap");
var wallet_1 = require("./wallet");
function hasPermit(contract) {
    var address = bootstrap_1.getAddress();
    if (!address)
        throw new Error('No address available');
    return localStorage.getItem("query_permit_" + (address + contract.at)) != null;
}
exports.hasPermit = hasPermit;
function enablePermit(contract, permissions) {
    if (permissions === void 0) { permissions = []; }
    return __awaiter(this, void 0, void 0, function () {
        var address, permit, permitName, allowedTokens, chainId, keplr, signature;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address = bootstrap_1.getAddress();
                    if (!address)
                        throw new Error('No address available');
                    permit = JSON.parse(localStorage.getItem("query_permit_" + (address + contract.at)));
                    if (!!permit) return [3, 4];
                    permitName = contract.at;
                    allowedTokens = [contract.at];
                    return [4, bootstrap_1.getChainId()];
                case 1:
                    chainId = _a.sent();
                    return [4, wallet_1.getKeplr()];
                case 2:
                    keplr = _a.sent();
                    if (!keplr)
                        throw new Error('No keplr is available');
                    return [4, keplr.signAmino(chainId, address, {
                            chain_id: chainId,
                            account_number: '0',
                            sequence: '0',
                            fee: {
                                amount: [{ denom: 'uscrt', amount: '0' }],
                                gas: '1',
                            },
                            msgs: [
                                {
                                    type: 'query_permit',
                                    value: {
                                        permit_name: permitName,
                                        allowed_tokens: allowedTokens,
                                        permissions: permissions,
                                    },
                                },
                            ],
                            memo: '',
                        }, {
                            preferNoSetFee: true,
                            preferNoSetMemo: true,
                        })];
                case 3:
                    signature = (_a.sent()).signature;
                    permit = {
                        params: {
                            permit_name: permitName,
                            allowed_tokens: allowedTokens,
                            chain_id: chainId,
                            permissions: permissions,
                        },
                        signature: signature,
                    };
                    localStorage.setItem("query_permit_" + (address + contract.at), JSON.stringify(permit));
                    _a.label = 4;
                case 4: return [2];
            }
        });
    });
}
exports.enablePermit = enablePermit;
//# sourceMappingURL=permits.js.map